module.exports = __webpack_public_path__ + "img/2-3.ff9edc7b.svg";